import { render, staticRenderFns } from "./PassAnimation.vue?vue&type=template&id=5aba531c&scoped=true"
import script from "./PassAnimation.vue?vue&type=script&lang=js"
export * from "./PassAnimation.vue?vue&type=script&lang=js"
import style0 from "./PassAnimation.vue?vue&type=style&index=0&id=5aba531c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aba531c",
  null
  
)

export default component.exports